import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import Assestment3 from '../../assets/image/assestment3.png'
import compentence from '../../assets/image/assestment/compentence.jpg'
export default class competency extends Component {
    render() {
        const image=[
            {image:compentence}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Assessment','Competency']} image={image} title="Competency" subtitle="We handle your awarding ceremony, top management seminars, public seminars, mega seminar, and workshops. We also manage all logistics involved in making successful and professional events."/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                Build & Development of Competency Dictionary<br/>
                                Competency is ability to be and the ability to interact with others follow by ability to know and ability to do that reflected in behavior and needed to apply in work.
                                <br/><br/>
                                <b>Types Of Competency In An Organization</b>
                                <br/><br/>
                                <div style={{width:'100%',textAlign:'center'}}>
                                    <img src={Assestment3} style={{width:'100%'}}/>
                                </div>
                                <br/><br/>
                                <b>Our Service:</b><br/>
                                1. Development of Competency Dictionary<br/>
                                2. Build Competency Dictionary<br/>
                                3. In House Competency Development Workshop<br/>

                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
